import { isFli, isGroup } from '@modeso/aumico-lib-templates-fe';
import {
    AccountMappingTemplateGroupItem,
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    ItemType,
    SortedMappingItem,
} from '@modeso/types__aumico-lib-annualreport-be';
import { IGatheringSortedItem as IGatheringItem } from './IGatheringSortedItem.interface';
import { Group } from './classes/Group';
import { SortedItem } from './classes/SortedGroup';

export class GatheringItems implements IGatheringItem {
    private _sortedItems: (SortedMappingItem | IAccountMappingSubFLI)[];
    private _groups: IAccountMappingTemplateGroup[];
    private _items: AccountMappingTemplateGroupItem[];

    constructor() {
        this._sortedItems = [];
        this._groups = [];
        this._items = [];
    }

    visitGroups(group: IAccountMappingTemplateGroup): void {
        this._groups.push(group);
        group.groups.forEach((group) => new Group(group).accept(this));
        group.items.forEach((item) => this._items.push(item));
    }

    visitSortedItems(sortedItem: SortedMappingItem | IAccountMappingSubFLI): void {
        this._sortedItems.push(sortedItem);
        if (isGroup(sortedItem)) {
            (sortedItem.sortedItems as SortedMappingItem[]).forEach((item) => {
                new SortedItem(item).accept(this);
            });
        } else if (isFli(sortedItem)) {
            sortedItem.accounts
                .filter((item) => item.type === ItemType.OF_THAT_ITEM || item.type === ItemType.SUB_FLI)
                .forEach((item: IAccountMappingSubFLI) => {
                    new SortedItem(item).accept(this);
                });
        }
    }

    get sortedItemsToTranslate(): (SortedMappingItem | IAccountMappingSubFLI)[] {
        return this._sortedItems;
    }

    get groupsToTranslate(): IAccountMappingTemplateGroup[] {
        return this._groups;
    }

    get itemsToTranslate(): AccountMappingTemplateGroupItem[] {
        return this._items;
    }
}
